import { PartialRecursive } from '@bridebook/models/source/abstract/_';
import { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';
import { PremiumTiers } from '@bridebook/toolbox/src/constants';

const result: PartialRecursive<IBucket['settings']> = {
  hasEssentials: {
    types: {
      included: ['venue'],
    },
  },
  freeTrial: {
    suppliers: {
      tier: PremiumTiers.Tier_1,
      days: 90,
      activation: 'signup',
    },
    venue: {
      tier: PremiumTiers.Tier_0_25,
      days: 60,
      activation: 'signup',
    },
  },
  hideLimitedProfiles: {
    types: {
      included: ['venue'],
    },
  },
  searchFilters: {
    venue: {
      overviewSection: [
        'highestReviewed',
        'exclusiveUse',
        'weddingLicence',
        'hasAccommodation',
        'lateNightExtensionAvailable',
        'alcoholLicense',
      ],
      venueType: [
        'countryHouseManorHouse',
        'barn',
        'gardenOutdoor',
        'statelyHome',
        'castle',
        'hotel',
        'cityHotelCityVenue',
        'warehouseFactory',
        'museumAttraction',
        'pubRestaurant',
        'golfCourse',
        'cruiseBoatYacht',
        'sportingVenueStadium',
        'conferenceCentre',
        'placeOfWorship',
        'townHallRegistryOffice',
        'otherVenueType',
      ],
    },
  },
  smartPricing: {
    types: {
      included: ['venue'],
    },
  },
};

export default result;
